const RESET_PASSWORD_REQUIRED_FIELDS = ["personEmailAddress"]

export const RequiredFields = {
  RESET_PASSWORD_REQUIRED_FIELDS,
}
